import React, { useEffect, useState } from 'react';

const SHOWN_KEY = 'wp_splash_shown';

const shouldShow = () => {
  if (sessionStorage.getItem(SHOWN_KEY)) return false;
  const isMobile = window.innerWidth < 768;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  return isMobile || isStandalone;
};

export const SplashScreen = () => {
  const [visible, setVisible] = useState(shouldShow);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem(SHOWN_KEY, '1');
    const t1 = setTimeout(() => setLeaving(true), 2100);
    const t2 = setTimeout(() => setVisible(false), 2700);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div data-testid="splash-screen" className={`splash-screen ${leaving ? 'splash-leave' : ''}`}>
      <div className="splash-glow" />
      <img src="/monogram-wp.png" alt="WP" className="splash-monogram" />
      <div className="splash-line" />
      <p className="splash-title">Dr Whanderson Pinheiro</p>
      <p className="splash-subtitle">Clínica Geral / Nutrologia</p>
    </div>
  );
};
